module.exports = __webpack_public_path__ + "static/media/matching-score-coin-50.bdacbf60.png";